package com.vizio.pay.api

import com.vizio.redwolf.pay.api.CustomerSupportApiImpl
import com.vizio.redwolf.pay.model.CreateSupportCaseRequest
import com.vizio.redwolf.pay.model.CustomerSupportResult
import com.vizio.redwolf.pay.model.SerialNumberRequest
import com.vizio.redwolf.utils.AppConfig
import com.vizio.redwolf.utils.PayEnvironment
import com.vizio.redwolf.utils.ResponseHeaders
import com.vizio.redwolf.utils.clientprovider.WebApiUseCase
import kotlin.js.Promise

@JsExport
class CustomerSupportJsApi(payEnv: PayEnvironment, jsClientConfig: JsClientConfig? = null) {
    private val customerSupport = CustomerSupportApiImpl(payEnv = payEnv,
                                                         appConfig = AppConfig(""),
                                                         clientConfig = jsClientConfig.toClientConfig(WebApiUseCase.COOKIE_SDK_HEADERS)
    )

    @JsName("validateSerialNumber")
    fun validateSerialNumber(serialNumber: String?): Promise<dynamic> {
        return handleJsPromiseRequest(exceptionHandler = ::handleCustomerJsException) {
            val serialNumberRequest = SerialNumberRequest(
                serialNumber = serialNumber
            )
            customerSupport.validateSerialNumber(serialNumberRequest)
        }
    }

    @JsName("getProductAssets")
    fun getProductAssets(id: String): Promise<dynamic> {
        return handleJsPromiseRequest(exceptionHandler = ::handleCustomerJsException) {
            customerSupport.getProductAssets(id)
        }
    }

    @JsName("getSupportHours")
    fun getSupportHours(): Promise<dynamic> {
        return handleJsPromiseRequest(exceptionHandler = ::handleCustomerJsException) {
            customerSupport.getSupportHours()
        }
    }

    @JsName("getProductFirmwareVersion")
    fun getProductFirmwareVersion(serialNumber: String): Promise<dynamic> {
        return handleJsPromiseRequest(exceptionHandler = ::handleCustomerJsException) {
            customerSupport.getProductFirmwareVersion(serialNumber)
        }
    }

    @JsName("createSupportCase")
    fun createSupportCase(phoneNumber: String, firstName: String, lastName: String, email: String? = null, modelNumber: String? = null, serialNumber: String? = null, notes: String? = null, callCustomerBack: Boolean? = null): Promise<dynamic> {
        return handleJsPromiseRequest(exceptionHandler = ::handleCustomerJsException) {
            val createSupportCaseRequest = CreateSupportCaseRequest(
                phoneNumber = phoneNumber,
                firstName = firstName,
                lastName = lastName,
                email = email,
                modelNumber = modelNumber,
                serialNumber = serialNumber,
                notes = notes,
                callCustomerBack = callCustomerBack
            )
            customerSupport.createSupportCase(createSupportCaseRequest)
        }
    }

    private fun <T: Any> handleCustomerJsException(ex: Exception, data: JsExceptionInfo<T>? = null): CustomerSupportResult.Error {
        return CustomerSupportResult.Error(ResponseHeaders.Invalid, Exception(jsRequestExceptionError))
    }
}
